<template>
	<transition name="modal">
		<div class="modal-mask" v-show="show">
			<div class="modal-container">
				<div class="modal-header">
					<h3>Editar Atendimento</h3>
				</div>
				<div class="modal-body">
					<form action="">
						<div class="row">
							<div class="col-md-4">
								<div class="form-group">
									<label>Sexo</label>
									<select class="form-control" v-model="$props.item.sexo">
										<option value="0">Ambos</option>
										<option value="1">Masculino</option>
										<option value="2">Feminino</option>
									</select>
								</div>
							</div>
							<div class="col-md-4">
								<div :class="{ 'form-group': true, 'has-error': errors.has('idade_minima') }">
									<label>Idade mínima</label>
									<input type="number" min="0" class="form-control" v-model="$props.item.idade_minima"
										   v-validate="$props.item.idade_maxima ? 'required|max_value:' + $props.item.idade_maxima : ''"
										   name="idade_minima" ref="idade_minima"/>
									<span v-show="errors.has('idade_minima')" class="help-block">Deve ser menor que a idade máxima</span>
								</div>
							</div>
							<div class="col-md-4">
								<div :class="{ 'form-group': true, 'has-error': errors.has('idade_maxima') }">
									<label>Idade máxima</label>
									<input type="number" max="110" class="form-control"
										   v-model="$props.item.idade_maxima"
										   v-validate="$props.item.idade_minima ? 'required|min_value:' + $props.item.idade_minima : ''"
										   name="idade_maxima" ref="idade_maxima"/>
									<span v-show="errors.has('idade_maxima')" class="help-block">Deve ser maior que a idade mínima</span>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-4">
								<div :class="{ 'form-group': true, 'has-error': errors.has('data') }">
									<label for="">Data: </label>
									<input v-model="$props.item.data_atendimento" class="form-control" type="date"
										   placeholder="DATA" v-validate="'required'" name="data" ref="data"/>
									<span v-show="errors.has('data')"
										  class="help-block">{{ errors.first("data") }}</span>
								</div>
							</div>
							<div class="col-md-4">
								<div :class="{ 'form-group': true, 'has-error': errors.has('hora_inicial') }">
									<label>Hora inicial</label>
									<input type="time" class="form-control" v-model="$props.item.hora_inicial"
										   v-validate="'required'" name="hora_inicial" ref="hora_inicial"/>
									<span v-show="errors.has('hora_inicial')" class="help-block">{{ errors.first("hora_inicial") }}</span>
								</div>
							</div>
							<div class="col-md-4">
								<div :class="{ 'form-group': true, 'has-error': errors.has('hora_final') }">
									<label>Hora final</label>
									<input type="time" class="form-control" v-model="$props.item.hora_final"
										   v-validate="'required'" name="hora_final" ref="hora_final"/>
									<span v-show="errors.has('hora_final')" class="help-block">{{ errors.first("hora_final") }}</span>
								</div>
							</div>
						</div>
					</form>
				</div>
				<div class="modal-footer">
					<div class="row">
						<div class="col-md-12">
							<button @click="salvar()" class="btn btn-primary pull-right" type="button"><i
								class="fa fa-save"></i> Salvar
							</button>
							<button tag="a" @click="$emit('close')" class="btn btn-default pull-left"><i
								class="fa fa-close"></i> Cancelar
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	import axios from "axios"; // Cliente para requisição http

	export default {
		props: ["show", "item", "tipo"],
		data: () => ({}),
		mounted() {
		},
		methods: {
			salvar() {
				this.$validator.validateAll().then(result => {
					if (result) {
						if (this.$props.tipo == "procedimento") {

								this.$swal({
									type: "warning",
									title: "ATENÇÃO!",
									text: "Modificar dia(s) e horário(s) dessa agenda mudará também o que já foi marcado\". Deseja realmente alterar?",
									showCancelButton: true,
									confirmButtonText: 'SIM',
									cancelButtonText: 'NÃO',
									showCloseButton: true,
									showLoaderOnConfirm: true
								}).then((result) => {
									if (result.value) {

										axios
											.post(`${this.$store.state.serverURI}/api/distribuicao/agenda/editarAtendimento/${this.$props.item.id}`, this.$props.item, this.$store.getters.getHeaderAuth)
											.then(response => {
												this.$store.commit("TOGGLE_LOADING");
												this.$swal({
													type: "success",
													title: "Atendimento atualizado com sucesso!",
													showConfirmButton: false,
													timer: 1500
												});
												this.$emit("atualizar");
												this.$emit("close");
											})
											.catch(error => {
												this.$store.commit("TOGGLE_LOADING");
												var erros = error.response.data.message + " ";
												for (var erro of Object.values(error.response.data.errors)) {
													erros += erro + " \n";
												}
												this.$swal({
													type: "error",
													title: "Houve uma falha!",
													text: erros
												});
											});
									} else {
										this.$props.item.autoChange = true
										this.$emit("close");
										this.$emit("criarAtendimento", this.$props.item);

									}
								})

						} else {
							this.$swal({
								type: "warning",
								title: "ATENÇÃO!",
								text: "Modificar dia(s) e horário(s) dessa agenda mudará também o que já foi marcado\". Deseja realmente alterar?",
								showCancelButton: true,
								confirmButtonText: 'SIM',
								cancelButtonText: 'NÃO',
								showCloseButton: true,
								showLoaderOnConfirm: true
							}).then((result) => {
								if (result.value) {
									axios
										.post(`${this.$store.state.serverURI}/api/distribuicao/agenda/editarAtendimentoSubgrupo/${this.$props.item.id}`, this.$props.item, this.$store.getters.getHeaderAuth)
										.then(response => {
											this.$store.commit("TOGGLE_LOADING");
											this.$swal({
												type: "success",
												title: "Atendimento atualizado com sucesso!",
												showConfirmButton: false,
												timer: 1500
											});
											this.$emit("atualizar");
											this.$emit("close");
										})
										.catch(error => {
											this.$store.commit("TOGGLE_LOADING");
											var erros = error.response.data.message + " ";
											for (var erro of Object.values(error.response.data.errors)) {
												erros += erro + " \n";
											}
											this.$swal({
												type: "error",
												title: "Houve uma falha!",
												text: erros
											});
										});
								} else {
									this.$props.item.autoChange = true
									this.$emit("close");
									this.$emit("criarAtendimento", this.$props.item);

								}
							})
						}
						this.$store.commit("TOGGLE_LOADING");
					}
				});
			}
		},
		watch: {}
	};
</script>

<style scoped>
	* {
		box-sizing: border-box;
	}
</style>



// WEBPACK FOOTER //
// editarAtendimentoModal.vue?79a9afbb